<list-renderer [listTemplate]="listTemplate" (onNextPage)="loadMore($event)"></list-renderer>
